// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--yuaEr","BodyContainerText":"_BodyContainerText--lGR7l","WarningIcon":"_WarningIcon--Q45v_","Heading":"_Heading--v__EJ"};